import type { FC } from "react";
import { StrictMode } from "react";
import { renderRoutes } from "react-router-config";
import { HashRouter } from "react-router-dom";

import { LocaleContext } from "@jti/app-context/contexts";
import type { CheckoutConfiguration } from "@jti/commerce";
import { CountrySetter } from "@jti/commerce/features";
import { CheckoutConfigurationProvider } from "@jti/commerce/providers";
import { QueryClient, QueryClientProvider } from "@jti/rest-api";
import { InsertGoogleRecaptcha } from "@jti/ui";

import { CampaignRunner } from "@checkout/components/CampaignRunner";

import { getRoutes } from "./routes";

export type StandardCheckoutAppProps = {
  data: CheckoutConfiguration;
  onNavigate?: (url: string) => void;
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

export const StandardCheckoutApp: FC<StandardCheckoutAppProps> = ({ data, onNavigate }) => {
  return (
    <StrictMode>
      <InsertGoogleRecaptcha />
      <LocaleContext.Provider value={"en-US"}>
        <CheckoutConfigurationProvider data={data}>
          <QueryClientProvider client={queryClient}>
            <CampaignRunner />
            <CountrySetter />
            <HashRouter>{renderRoutes(getRoutes(onNavigate))}</HashRouter>
          </QueryClientProvider>
        </CheckoutConfigurationProvider>
      </LocaleContext.Provider>
    </StrictMode>
  );
};
